const APP_CONFIG = {
  loadingDuration: 1000,
  nestio: {
    base_url: "https://nestiolistings.com/api/v2/appointments/group/",
  },
};

export default APP_CONFIG;
